import React, { useContext, useEffect } from "react";
import Header from "../../components/header/Header";
import SliderHomePage from "../../components/sliderHomePage/SliderHomePage";
import AboutUsHome from "../../components/aboutUs-Homepage/AboutUsHome";
import ProductsHome from "../../components/products-homepage/ProductsHome";
import NewsHome from "../../components/newsHome/NewsHome";
import CertificatesHome from "../../components/certificatesHome/CertificatesHome";
import Footer from "../../components/footer/Footer";
import LoadingPage from "../../components/loadingPage/LoadingPage";
import { dataContext } from "../../context/DataContextProviderr";

const HomePage = ({ setIndexProducts }) => {
  const { isLoading } = useContext(dataContext);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <div className="overflow-hidden">
          {/* <Header /> */}
          <SliderHomePage />
          <AboutUsHome />
          <ProductsHome setIndexProducts={setIndexProducts} />
          <NewsHome />
          <CertificatesHome />
          <Footer />
        </div>
      )}
    </>
  );
};

export default HomePage;
